import AuthenticationStore from '~/auth/authenticationStore';
import { auth, rolodex } from '~/services/serviceInstances';

export async function domainCheck(data) {
  const rolodexConfigs = await rolodex.get(
    `public/auth-configs/${data.client}`,
  );

  const enableRolodex = rolodexConfigs.signin_enabled;
  if (!enableRolodex) {
    const aegisConfigs = await auth.post('auth/login-info', data);

    return {
      enableRolodex,
      password: {
        enabled: aegisConfigs.password.enabled,
      },
      sso: aegisConfigs.sso,
      oauth: {
        enabled: false, // Aegis has no oauth option
      },
      oidc: {
        enabled: false, // Aegis has no oidc option
      },
    };
  } else {
    return {
      enableRolodex,
      password: {
        enabled: rolodexConfigs.password_signin_enabled,
      },
      sso: {
        enabled: rolodexConfigs.sso_signin_enabled,
        // TODO: Add the following fields to the response when rolodex supports SSO
        provider_name: '',
        signon_url: '',
        error: '',
      },
      oauth: {
        enabled: rolodexConfigs.oauth_signin_enabled,
      },
      oidc: {
        enabled: rolodexConfigs.oidc_signin_enabled,
        error: enableRolodex
          ? ''
          : // TODO: Due to i18n standards, this error shouldn't live here, consider moving it to the Backend
            'Cannot use OIDC without Auth service enabled',
      },
    };
  }
}

export async function loginWithClientUsernamePassword(data) {
  return await auth.post('auth/login', data);
}

export async function loginWithToken(token) {
  return await auth.post('auth/login-token', token);
}

export async function logoutAegis() {
  try {
    return await auth.post(
      '/auth/logout',
      {},
      {
        withCredentials: true,
      },
    );
  } catch (error) {
    if (error.response?.status === 401) {
      console.log('session expired');
    } else {
      throw error;
    }
  }
}

export async function logoutRolodex() {
  try {
    return await rolodex.post(
      'proxy/sign-out',
      {},
      {
        withCredentials: true,
      },
    );
  } catch (error) {
    if (error.response?.status === 401) {
      console.log('session expired');
    } else {
      throw error;
    }
  }
}

export async function logout() {
  const AS = AuthenticationStore();

  if (AS.isRolodexAuthed()) {
    return logoutRolodex();
  } else {
    return logoutAegis();
  }
}

export async function inactivityTimeoutLogout() {
  const AS = AuthenticationStore();

  if (AS.isRolodexAuthed()) {
    return inactivityTimeoutLogoutRolodex();
  } else {
    return logoutAegis();
  }
}

export function submitOpcLogoutFormRequest({
  action,
  id_token_hint,
  oidc_client_id,
}) {
  const url = new URL(action);
  url.searchParams.set('id_token_hint', id_token_hint);
  url.searchParams.set('client_id', oidc_client_id);

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url.toString();

  document.body.appendChild(form);
  form.submit();
}

export function getOneTimeUseToken() {
  return auth.post('/auth/user-one-use-token', {}, { withCredentials: true });
}

export function getUserEditorConfigToken(data) {
  return auth.post('/auth/user-editor-config', data, { withCredentials: true });
}

export function getForceSaveToken(data) {
  return auth.post('/auth/force-save-token', data, { withCredentials: true });
}
